import {Injectable, Injector} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import * as fromAuthModule from '@orga-app/auth/reducer';
import {LoadingController} from '@ionic/angular';
import {PageState} from './mitteilungen.reducer';
import {Observable} from 'rxjs/Observable';
import {filter, flatMap, map, withLatestFrom} from 'rxjs/operators';
import {getAktuelleVeranstaltung} from '../../app-state/app-state.reducer';
import {Veranstaltung} from '../../../../clients/veranstaltungen';
import {
    GetMitteilungenGesendetGruppiertAction, GetMitteilungenGruppiertAction, GetVeranstaltungBerechtigungAction,
    GetVeranstaltungFunktionsbereicheAction, GetVeranstaltungMitteilungBerechtigungAction, GetVeranstaltungMitteilungsVorlagenAction
} from '../../../../client-ngrx/veranstaltungen';
import {AKTUELLE_VERANSTALTUNG_SETZEN, AktuelleVeranstaltungSetzenAction} from '../../app-state/actions/veranstaltung.actions';
import {PAGE_STATE_RESET, PageStateResetAction} from './mitteilungen.actions.ui';

@Injectable()
export class MitteilungenPageUiEffects {

    @Effect()
    datenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(PAGE_STATE_RESET),
        withLatestFrom(this.store$.pipe(select(getAktuelleVeranstaltung))),
        filter(([x, aktuelleVeranstaltung]: [PageStateResetAction, Veranstaltung]) => aktuelleVeranstaltung !== null),
        flatMap(([x, aktuelleVeranstaltung]: [PageStateResetAction, Veranstaltung]) =>
            [new GetMitteilungenGruppiertAction(aktuelleVeranstaltung.veranstaltung_id),
            new GetMitteilungenGesendetGruppiertAction(aktuelleVeranstaltung.veranstaltung_id),
            new GetVeranstaltungFunktionsbereicheAction(aktuelleVeranstaltung.veranstaltung_id),
            new GetVeranstaltungBerechtigungAction(aktuelleVeranstaltung.veranstaltung_id),
            new GetVeranstaltungMitteilungBerechtigungAction(aktuelleVeranstaltung.veranstaltung_id),
            new GetVeranstaltungMitteilungsVorlagenAction(aktuelleVeranstaltung.veranstaltung_id)]
        )
    );

    @Effect()
    aktuelleVeranstaltungSetzen$: Observable<Action> = this.actions$.pipe(
        ofType(AKTUELLE_VERANSTALTUNG_SETZEN),
        map((x: AktuelleVeranstaltungSetzenAction) => x),
        filter(x => x.payload != null),
        map(x => x.payload),
        filter(x => x.veranstaltung_id != null),
        flatMap((x) =>
            [new GetMitteilungenGruppiertAction(x.veranstaltung_id),
                new GetMitteilungenGesendetGruppiertAction(x.veranstaltung_id),
                new GetVeranstaltungFunktionsbereicheAction(x.veranstaltung_id),
                new GetVeranstaltungBerechtigungAction(x.veranstaltung_id),
                new GetVeranstaltungMitteilungBerechtigungAction(x.veranstaltung_id),
                new GetVeranstaltungMitteilungsVorlagenAction(x.veranstaltung_id)]
        )
    );

    constructor(private actions$: Actions,
                private store$: Store<PageState>,
                private storeAuth: Store<fromAuthModule.ModuleState>,
                public loadingCtrl: LoadingController,
                private injector: Injector) {
    }
}
